import React from "react";
import { Select } from "antd";
import countries from "utils/country.json";

const AutoCompleteCountry = ({ value, onChange }) => {
  return (
    <Select
      showSearch
      value={value}
      onChange={onChange}
      placeholder="Selecione um país"
      style={{ width: "100%" }}
      optionFilterProp="label"
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase()) ||
        option.value.toLowerCase().includes(input.toLowerCase())
      }
      options={countries.map((c) => ({
        value: c.code,
        label: `${c.name} (${c.code})`,
      }))}
    />
  );
};

export { AutoCompleteCountry };